module.exports = __webpack_public_path__ + "static/fonts/Avenir-Black.212f3f0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Avenir/Avenir-Black.ttf
// module id = 9K6Y
// module chunks = 0